import qs from 'qs';
import Request from '@ued/request';
import axios from 'axios';

const isLocation = location.hostname === 'localhost';
const request = new Request(
  axios,
  {
    baseURL: isLocation ? '/VEGA' : process.env.VUE_APP_API_VEGA_URL,
    timeout: 15000,
    transformRequest: [data => qs.stringify(data)],
    // 自定义配置，可以配合 interceptors 一起使用
    showLoading: false,
    showCodeError: true,
    showNetworkError: true,
    vega: {
      // 可以选择，自己判断相关环境的accessId和secretKey，0.6.0开始支持
      'ntocc-bff': {
        accessId: process.env.VUE_APP_API_VEGA_ACCESSID,
        secretKey: process.env.VUE_APP_API_VEGA_SECRETKEY,
      },
    },
    signType: 'sign2',
  },
  {
    response: [
      function (response) {
        const { code, sub_code, data } = response.data;

        if (code === 0 && sub_code === 0) {
          return data;
        }

        return Promise.reject(response);
      },
    ],
  },
);

export default request.createApi({
  'getConfig GET': '/v1/ntocc-bff/config',
  'getSignature GET': '/v1/ntocc-bff/wechat/getSignature',
});
